<template>
  <div class="main">
    <router-view />
    <Tabbar />
  </div>
</template>

<script>
import Tabbar from "@/components/tabbar/index.vue";

export default {
  name: 'Main',
  components: {
    Tabbar
  }
}
</script>
<style>
</style>